import * as constants from '../constants';

export const organizationRequest = () => ({type: constants.ORGANIZATION_REQUESTED});
export const organizationSuccess = (item) => ({type: constants.ORGANIZATION_SUCCESS, payload: {item}});
export const organizationFailure = (error) => ({type: constants.ORGANIZATION_FAILURE, payload: {error}});
export const organizationEditRequest = (item) => ({type: constants.ORGANIZATION_EDIT_REQUESTED, payload: {item}});
